const QUERY_PARAM = '_unsupportedVantageDataModel';

/**
 * CRAB-60996
 *
 * Resolves an unsupported `?_unsupportedVantageDataModel=CSRM|SSRM` override for the Vantage Evidence
 * Table row model. Returns `true` to force SSRM, `false` to force CSRM, or `undefined` when no (valid)
 * override is present, in which case callers fall back to the server feature flag.
 */
export function getVantageDataModelOverride(): boolean | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const mode = new URLSearchParams(window.location.search).get(QUERY_PARAM)?.toUpperCase();
  const override = mode === 'SSRM' ? true : mode === 'CSRM' ? false : undefined;

  return override;
}
